module.exports = __webpack_public_path__ + "static/media/21ECLAC46.8f6ae875.jpg";